import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { RotatingLines } from "react-loader-spinner";

const Modals = ({ loading, ...props }) => {
  return (
    <div className="Modal">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modalMain"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <div>
            <img loading="lazy" src={props.images} />
            <p>{props.description}</p>
            <div className="modal-buttons">
              <button onClick={props.onHide}>{props.firstbutton}</button>
              <button
                onClick={() => {
                  props.UnsubscribeHandler(props.categoryId, props.cityId);
                }}
              >
                {loading === true ? (
                  <RotatingLines
                    strokeColor="white"
                    width={20}
                    visible={true}
                  />
                ) : (
                  props.secondbutton
                )}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Modals;
